import LocalizedStrings from "react-localization"; // added new strings in cp and created web report strings
import ProjectDetailsReportPage from "screens/Report/projectDetailsReport";
const strings = new LocalizedStrings({
  en: {
    // defaul error
    initialError: {
      data: {
        status: 501,
        message: "Internal error, Please try again!",
      },
    },
    sno: "S. No.",
    tableDataErr: "Data Not Available",
    modify: "Modify",
    download: "Download",
    // Login

    Login: "Sign in",
    enterUsernameAndPass: "Enter your email and password to continue.",
    username: "Email address",
    password: "Password",
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Enter your password",
    loginemail: "Email is required.",
    loginpassword: "Password is required.",
    forgotPass: "Forgot password?",
    login: "Sign in",
    loginTermsPrefix: "By signing in, you agree to our",
    loginTermsLink: "Terms and Conditions",
    loginPrivacyLink: "Privacy Policy",
    companyTagline: "Built for real growth",
    loginHeroHeadline:
      "Transform your real estate operations with clarity and control.",
    loginHeroSupport: "Built for real growth",
    termsPageTitle: "Terms and Conditions",
    termsPageIntro:
      "A short summary of how you may use Justo. Open a section below for details.",
    termsBack: "Go back",
    termsOverviewTitle: "Overview",
    termsOverviewBody:
      "These terms govern your use of our application. By accessing or using the app, you agree to comply with them.",
    termsSection1Title: "1. Acceptance of Terms",
    termsSection1Body:
      "By using this app, you agree to the terms laid out here and in any future updates. If you do not agree, please do not use the application.",
    termsSection2Title: "2. Use of the App",
    termsSection2Body:
      "You may use the app only for lawful purposes. Unauthorized access, misuse, or abuse of the services is prohibited.",
    termsSection3Title: "3. Privacy",
    termsSection3Body:
      "We collect and process data in accordance with our privacy policy. Please review the privacy policy for details.",
    termsSection4Title: "4. Intellectual Property",
    termsSection4Body:
      "All content, trademarks, and materials in the app are owned by or licensed to Justo. You may not reproduce or distribute them without permission.",
    termsSection5Title: "5. Limitation of Liability",
    termsSection5Body:
      "Justo is not responsible for indirect, incidental, or consequential damages arising from your use of the app.",
    termsSection6Title: "6. Changes to Terms",
    termsSection6Body:
      "We may update these terms periodically. Continued use after changes constitutes acceptance.",
    termsSection7Title: "7. Contact",
    termsSection7Body:
      "If you have questions about these terms, please contact support through the app.",
    privacyPageTitle: "Privacy Policy",
    privacyPageIntro:
      "How Justo collects, uses, and protects your information. Open a section below for details.",
    privacyBack: "Go back",
    privacyOverviewTitle: "Overview",
    privacyOverviewBody:
      "We respect your privacy. This policy explains what data we collect when you use Justo and how we use it.",
    privacySection1Title: "1. Information We Collect",
    privacySection1Body:
      "We may collect account details (such as name, email, and phone), usage activity within the app, and information you submit while managing visitors, bookings, and related workflows.",
    privacySection2Title: "2. How We Use Information",
    privacySection2Body:
      "We use your information to operate and improve Justo, authenticate users, support customer workflows, send important service communications, and meet legal or compliance obligations.",
    privacySection3Title: "3. Sharing of Information",
    privacySection3Body:
      "We do not sell your personal information. We may share data with authorized team members, trusted service providers who help run the platform, or when required by law.",
    privacySection4Title: "4. Data Security",
    privacySection4Body:
      "We apply reasonable administrative and technical safeguards to protect information. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.",
    privacySection5Title: "5. Data Retention",
    privacySection5Body:
      "We retain information for as long as needed to provide the service, fulfill the purposes described in this policy, and comply with legal or operational requirements.",
    privacySection6Title: "6. Your Choices",
    privacySection6Body:
      "Depending on your role and permissions, you may update profile details in the app or contact your organization administrator / Justo support to request corrections or account-related changes.",
    privacySection7Title: "7. Contact",
    privacySection7Body:
      "If you have questions about this privacy policy, please contact support through the app.",

    // Forgot Password

    forgotpass: "Forgot password",
    enterEmailForResetPass: "Enter your email to receive a one-time password.",
    yourEmail: "Email",
    backToLogin: "Back to login",
    sendOTP: "Send OTP",

    // Verify OTP

    verifyOTP: "VERIFY OTP",
    enterOTPRecivedOnEmail: "Enter OTP Recived On Email",
    enterOPT: "Enter OTP",
    resendOTP: "Resend OTP",
    changeEmail: "Change Email",
    otpSentTo: "OTP sent to",
    verify: "Verify",

    // Change Password
    changepass: "Change Password",
    enterNewPass:
      "Update your account password. Enter your current password, then choose a new one.",
    newPass: "New Password",
    currentPassword: "Current Password",
    confirmPass: "Confirm Password",
    changepassword: "Update Password",
    showPassword: "Show password",
    hidePassword: "Hide password",
    currentPasswordRequired: "Please enter your current password.",
    currentPasswordChecking: "Checking current password…",
    currentPasswordCorrect: "Current password is correct.",
    currentPasswordIncorrect: "The current password is incorrect.",
    newPasswordChecking: "Checking new password…",
    newPasswordCorrect: "This password can be used.",
    newPasswordRequired: "Please enter a new password.",
    forceChangePasswordMessage:
      "You signed in with the default password. Please set a new password to continue.",
    forceChangePasswordTitle: "Set a new password",
    forceChangePasswordNotice:
      "This password is the shared default. Choose a personal password to continue. You cannot use the default password again.",
    defaultPasswordNotAllowed:
      "The new password cannot be the default password. Please choose a different one.",
    confirmPasswordRequired: "Please confirm the new password.",
    passwordsDoNotMatch: "The new passwords do not match.",
    newPasswordSameAsCurrent:
      "The new password must be different from the current password.",
    signOut: "Sign out",

    //   header
    Search: "Search...",
    notification: "Notification",
    profile: "Profile",
    changePassword: "Change Password",
    userPasswordSend: "Reset Password",
    roleChange: "Role Change",
    propertyAllocate: "Property Allocate",
    separateLink: "Separate Link",
    logout: "Logout",
    logoutConfirmTitle: "Sign out now?",
    logoutConfirmMessage: "Are you sure you want to sign out on this device?",

    // Dashboard

    dashboard: "DASHBOARD",
    noOfProperty: "Total Property",
    activeAllocatedProperties: "Active Allocated Properties",
    noOfUser: "Total User",
    channelParters: "Total Channel Partner",
    visitorUpdate: "VISITOR UPDATE",
    todatyVisit: "Today Lead",
    todayAppointment: "Today Site Visit", // legacy; use todayWalkins for dashboard
    todayFollowup: "Today Followup",
    todayFollowUpButton: "Today's Follow-Up",
    pendingFollowups: "Pending Followups",
    todayWalkins: "Today's Walk-ins",
    notInterestedVisitors: "Not Interested Visitors",
    todayRevisitsScheduled: "Today's Revisits Scheduled",
    todayBooking: "Today Booking",
    todayRegistration: "Today Registration",
    totalAppointment: "Total Site Visit",
    totalFollowup: "Total Followup",
    totalBooking: "Total Booking",
    totalRegistration: "Total Registration",
    todayRaiseTicket: "Today Raise Ticket",
    openRaiseTicket: "Open Raise Ticket",
    visitG: "Visit",
    appointmentG: "Appointment",
    followupG: "Followup",
    bookingG: "Booking",
    registrationG: "Registration",
    marketValue: "MARKET VALUE",
    performance: "Performance",
    newchannelPartner: "NEW CHANNEL PARTNER",
    month: "Month",
    today: "Today",
    seemore: "See more",
    follow: "Follow",
    recentNotification: "RECENT NOTIFICATION",
    all: "All",
    order: "Order",
    trash: "Trash",
    calculation: "CALCULATION",
    newLead: "New Lead",
    visitTarget: "Visit Target",
    sitevisitTarget: "Site Visit Target",
    closingTarget: "Closing Target",
    totalSiteVisit: "Total Site Visit",
    totalCloseVisit: "Total Close Visit",
    totalVisit: "Total Lead",
    activeCP: "Active CP",
    conversionRate: "Conversion Rate",
    closingScore: "Closing Score",
    recovery: "Recovery",
    cancelBooking: "Cancel Booking",
    appointmentNumber: "Appointment Number",
    walkingNumber: "Walking Number",
    todayCheckin: "Today's Checkin",
    totalCheckin: "Total Checkin",
    todayAppointmentWithCp: "Today Appointment with Cp",
    activeSm: "Active SM",
    activeCm: "Active CM",

    // Footer

    copyright: "© 2022–2026 Justo · All rights reserved",

    // Common_Using_Keys
    notavailable: "NA",
    dataNotFound: "Data Not Available",
    imageNotFound: "Image Not Available",

    // User_index
    user: "USER",
    userManagement: "User management",
    userListing: "User Listing",
    userListSubtitle:
      "Filter users by date, role, name, email, and status. View profiles and manage access.",
    startDate: "Start Date",
    endDate: "End Date",
    byRole: "Search By Role",
    searchByEmail: "Search By Email",
    searchByParentName: "Search By Parent Name",
    searchParentName: "Search Parent Name",
    searchEmail: "Search Email",
    search: "Search",
    reset: "Reset",
    addNewUser: "Add New User",
    listOfUsers: "LIST OF USER'S",
    image: "Image",
    createdDate: "Created Date",
    name: "Name",
    contactNo: "Contact No.",
    emailId: "Email Id",
    type: "Type",
    action: "Action",
    total_users: "Total Users",
    viewUser: "View User",
    edituser: "Edit User",
    DeactiveUser: "Deactive User",
    deactive: "Deactive",
    selectrole: "Select Role",
    selectRole: "--Select Role--",
    editProfile: "Edit Profile",
    dashboardProfile: "Dashboard",
    editprofile: "EDIT PROFILE",
    profileDetail: "Profile Details",
    profileDetails: "PROFILE DETAILS",
    parentname: "Parent Name",
    agent_name: "Agent Name",
    selectall: "Select All",
    searchByCity: "Search By City Name",

    // Add New User
    addnewuser: "ADD NEW USER",
    selectImage: "Upload your image",
    addnewUser: "ADD NEW USER",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Id",
    emailaddress: "name@example.com",
    EmailUsername: "Username",
    mobileNo: "Mobile Number",
    referrerNumber: "Referrer Mobile No.",
    referrerName: "Referrer Name",
    referrerRequired: "Referrer required.",
    referrer: "Referrer",
    gender: "Gender",
    male: "Male",
    female: "Female",
    dob: "Date Of Birth",
    city: "City",
    address: "Address",
    area: "Area",
    role: "Role",
    sourcingTL: "Sourcing TL",
    selectSourcingTL: "--Select Sourcing TL--",
    closingTL: "Closing TL",
    selectClosingTL: "--Select Closing TL--",
    selectuser: "--Select User--",
    selectLoginType: "-- Select Login Type --",
    submit: "Submit",
    allFieldRequired: "Please fill in all required fields.",
    loginAccess: "Login Access",
    justoEmpCode: "Justo Employee Code",
    justoEmp: "Justo Emp. Code",
    referrerEmail: "Referrer Email",

    // View User
    userDetails: "USER DETAILS",
    viewuserdetails: "View User Details",
    age: "Age",
    userInfo: "Details",
    noOfBooking: "Total Booking",
    noOfCloseVisit: "Total Close Visit",
    lastVisitAttend: "Last Visit Attend",
    lastBooking: "Last Booking",
    lastReadyBooking: "Last Ready Booking",
    closeTarget: "Close Target",
    currentTarget: "Current Target",
    projectsName: "Projects Name",
    allocatedProps: "Allocated Properties",

    // Edit User
    editUser: "EDIT USER",
    editImage: "Edit your image",
    update: "Update",
    cancel: "Cancel",

    //  Deactive User
    activeUser: "Active User",
    deactiveUser: "Deactive User",
    areYouSure: "Are you sure?",
    deactiveThisUser: "Deactive This User !",
    youWantChangePassword: "You want to reset password !",
    resetPasswordConfirmTitle: "Reset this user’s password?",
    resetPasswordConfirmMessage:
      "The password will be reset to the default password. Do you want to continue?",
    resetPasswordConfirmIntro:
      "Review who you’re resetting, then confirm. Only this login is affected.",
    resetPasswordUserLabel: "User",
    resetPasswordWhatHappens: "What will happen",
    resetPasswordWarningDefault:
      "Password will be set to the current system default.",
    resetPasswordWarningSingleOnly:
      "Only this user is updated — nobody else is changed.",
    resetPasswordWarningNoEmail:
      "No email will be sent. Share login details with them separately if needed.",
    resetPasswordWarningWithEmail:
      "A notification email will be sent. It will not include login credentials.",
    resetPasswordEmailToggleHint:
      "Optional — notifies them that their password was reset. Credentials are not emailed.",
    resetPasswordEmailMissing:
      "This user has no email on file, so a notification cannot be sent.",
    confirmResetPassword: "Reset password",
    yes: "Yes",
    no: "No",

    activeThisUser: "Active This User !",

    inventryEditDetail: "only enter a number greater than the current number",

    //user error
    role_idErr: " Role is required.",
    parentErr: " Parent is required.",
    user_idErr: " Sourcing TL is required.",
    closing_tlErr: "Closing TL is required.",
    profileImageErr: "Profile Photo is required.",
    firstnameErr: "First name is required.",
    nameValidErr: "Visitor name should contain only alphabets",
    lastnameErr: "Last name is required.",
    emailErr: "Email Id is required.",
    mobileErr: " Mobile number is required.",
    mobileValidErr: "Please enter valid mobile number.",
    whatsAppNumber: "Whats'app Number is required.",
    emailRequire: "Email is require. Please enter email",
    emailAddressValidErr: "Please enter valid email.",
    otpErr: "OTP is required.",
    otpVerfiyValidErr: "Please Enter Valid OTP.",
    genderErr: "Gender is required.",
    dateofbirthErr: "Date of birth is required.",
    dateofbirthErr2: "You have to be older than 18.",
    addressErr: "Address is required.",
    cityErr: "City is required.",
    validAddressErr: "Please select valid area.",
    areaErr: "Area is required.",
    ageErr: "Age is required.",
    newPasswordErr: "Password is require. Please enter password.",
    newPasswordValidErr: "Please enter valid password.",
    login_type: "Please select user login access.",
    login_access: "Login access",
    justoEmpCodeErr: "Justo employee code is required.",
    // new
    confirmPasswordError: "Password and confirm password should be same.",
    passwordError: "Password should not be empty.",
    emptypassword: "Password should not be empty.",

    // Property_index
    Property: "PROPERTY",
    propertyListing: "Property Listing",
    searchByLocation: "Search By Location",
    searchBylocality: "Search By Locality",
    searchlocality: "Search Locality",
    searchByName: "Search By Name",
    searchByProjectName: "Search By Project Name",
    searchProjectName: "Search Project Name",
    searchName: "Search Name",
    searchByType: "Search By Type",
    addNewProperty: "Add New Property",
    syncAllProperty: "Sync All Project from JW",
    propertyList: "LIST OF PROPERTIES",
    propertyListSubtitle: "Search and manage projects across localities and statuses.",
    projectName: "Project Name",
    bookingVisit: "Booking",
    location: "Location",
    vistior: "Visitor",
    sitevisit: "Site Visit",
    closeVisit: "Registration",
    status: "Status",
    totalFlat: "Total Flat",
    soldOut: "Sold Out",
    viewProperty: "View Property",
    editProperty: "Edit Property",
    activeProperty: "Active Property",
    deactiveProperty: "Deactive Property",
    activatePropertyTitle: "Activate property",
    deactivatePropertyTitle: "Deactivate property",
    activatePropertyMessage:
      "{{property}} will be marked active and available for allocation and visits.",
    deactivatePropertyMessage:
      "{{property}} will be marked inactive and hidden from active listings.",
    confirmActivate: "Yes, activate",
    confirmDeactivate: "Yes, deactivate",
    greMobileOtp: "GRE Mobile OTP",
    greMobileOtpTitle: "Visitor OTP",
    greMobileOtpHint: "GRE phone verification",
    greMobileOtpEnabled: "Enabled",
    greMobileOtpDisabled: "Disabled",
    greMobileOtpOn: "On",
    greMobileOtpOff: "Off",
    greMobileOtpActivatedTitle: "Phone verification enabled",
    greMobileOtpActivatedMessage:
      "GRE staff at {{property}} must verify the visitor's phone number with OTP before adding a new lead.",
    greMobileOtpDeactivatedTitle: "Phone verification disabled",
    greMobileOtpDeactivatedMessage:
      "GRE staff at {{property}} can add visitors without verifying the phone number.",
    greMobileOtpUpdateFailedTitle: "Could not update phone verification",
    otpSmsConfigButton: "SMS config",
    otpSmsConfigModalTitle: "Property OTP SMS configuration",
    otpSmsConfigModalSubtitle:
      "Click Connect credentials for this property. Leave auth key blank to keep the saved key.",
    otpSmsConfigAuthKey: "Auth key",
    otpSmsConfigAuthKeyPlaceholder: "Enter authentic-key",
    otpSmsConfigAuthKeyHint: "Saved key: {{hint}}",
    otpSmsConfigSenderId: "Sender ID",
    otpSmsConfigApiUrl: "API URL",
    otpSmsConfigRoute: "Route",
    otpSmsConfigTemplateId: "Template ID",
    otpSmsConfigMessage: "OTP message template",
    otpSmsConfigMessageHint: "Use {{site}} and {{otp}} placeholders.",
    otpSmsConfigDefaultSite: "Default site name",
    otpSmsConfigSmsMode: "SMS delivery",
    otpSmsConfigSmsModeOff: "Off (dev OTP, no SMS)",
    otpSmsConfigSmsModeStaging: "Staging (sends SMS)",
    otpSmsConfigSmsModeProduction: "Production (sends SMS)",
    otpSmsConfigDeliveryDev: "Dev OTP (in-app)",
    otpSmsConfigDeliveryPhysical: "Physical SMS",
    otpSmsConfigDeliveryDevHint:
      "OTP is shown in the app only. No SMS is sent to the visitor's phone.",
    otpSmsConfigDeliveryPhysicalHint:
      "OTP is sent as a real SMS to the visitor's phone. Each message is deducted from your SMS vendor balance.",
    otpSmsConfigLiveGateway: "SMS gateway",
    otpSmsConfigSave: "Save configuration",
    otpSmsConfigClear: "Clear configuration",
    otpSmsConfigMissingCredsTitle: "SMS credentials required",
    otpSmsConfigMissingCredsMessage:
      "{{mode}} mode requires Click Connect credentials. Add the auth key and sender ID, or change SMS mode to Off.",
    otpSmsConfigMissingCredsConfirm: "OK",
    otpSmsConfigProdDevModeTitle: "Visitors will not receive SMS",
    otpSmsConfigProdDevModeMessage:
      "This backend is using the production database, and visitor OTP is enabled for this property. Setting SMS mode to {{mode}} means visitors will not receive a physical SMS. The OTP will only be shown in the app (dev OTP). Continue only if you intend this for testing.",
    otpSmsConfigProdDevModeConfirm: "Continue without SMS",
    otpSmsConfigStagingLiveSmsTitle: "Physical SMS will be sent",
    otpSmsConfigStagingLiveSmsMessage:
      "Physical SMS sends a real message to the visitor's phone through the SMS vendor. Each OTP will be deducted from your SMS vendor balance. Continue only if this is intended.",
    otpSmsConfigStagingLiveSmsConfirm: "Continue and send SMS",
    otpSmsConfigClearConfirm:
      "Remove OTP SMS credentials for this property? SMS will stay off until you save a new config.",
    otpSmsConfigSavedTitle: "OTP SMS configuration saved",
    otpSmsConfigClearedTitle: "OTP SMS configuration cleared",
    otpSmsConfigLoadFailedTitle: "Could not load OTP SMS configuration",
    otpSmsConfigSaveFailedTitle: "Could not save OTP SMS configuration",
    otpSmsConfigClearFailedTitle: "Could not clear OTP SMS configuration",
    otpSmsConfigEncryptionMissing:
      "Server encryption key is not configured. Ask engineering to set PROPERTY_CONFIG_ENCRYPTION_KEY.",
    otpSmsConfigNotConfigured: "No SMS account saved for this property yet",
    otpSmsConfigConfigured: "Property SMS account configured",
    // GRE per-property banner labels (super admin listing + visitor form).
    greBannerTitle: "GRE Banner",
    greBannerHint:
      "Shown on GRE visitor form. Recommended: 1000 × 300 px (displayed at 500 × 150 px), JPG or PNG, max 5 MB.",
    greBannerUpload: "Upload",
    greBannerReplace: "Replace",
    greBannerRemove: "Remove",
    greBannerPreview: "Preview",
    greBannerUpdatedTitle: "Banner updated",
    greBannerRemovedTitle: "Banner removed",
    greBannerUpdateFailedTitle: "Could not update banner",
    greBannerRemoveTitle: "Remove GRE banner",
    greBannerRemoveMessage:
      "Remove the GRE banner for {{property}}? The image will be deleted from memory.",
    greBannerRemoveConfirm: "Yes, remove",
    greBannerUploadModalTitle: "Upload GRE banner",
    greBannerUploadModalReplaceTitle: "Replace GRE banner",
    greBannerUploadFormats: "Supported formats: JPEG, PNG, WebP",
    greBannerUploadMaxSize: "Maximum file size: 5 MB",
    greBannerUploadRecommendedSize:
      "Recommended size: 1000 × 300 px (displayed at 500 × 150 px)",
    greBannerUploadSelectFile: "Choose image",
    greBannerUploadSubmit: "Upload banner",
    greBannerInvalidFormat: "Only JPEG, PNG, or WebP images are allowed.",
    greBannerFileTooLarge: "Image must be 5 MB or smaller.",
    greBannerUploadSelectFileHint: "Drag and drop or click to browse",
    greBannerUploadClearSelection: "Remove image",
    searchByOtpVerification: "Search By OTP Verification Status",
    selectOtpVerification: "--Select OTP Status--",
    crmPersonEmail: "CRM Person Email Id",
    jqProjectID: "JW Project Id",

    // Add New Property

    propertyNameExits: "This Project name is already exits with our system.",
    propertyNameExitsConfirm:
      "Are you sure you want to create new project with same name?",
    addnewproperty: "ADD NEW PROPERTY",
    locationArea: "Location Area",
    typeOfProperty: "Type Of Property",
    costing: "Costing",
    configuration: "Configurations",
    min: "Minimum Budget",
    max: "Maximum Budget",
    inventry: "Inventry",
    remaining: "Remaining",
    amenity: "Amenities",
    optional: "Optional",
    next: "Next",
    Content: "Content",
    addCompetitorProperty: "Add Competitor Property",
    leadFollowup: "Lead Followup",
    propertyAllocation: "Property Allocation",
    selectUser: "Select User",
    selectManager: "Select Manager",
    insentive: "Incentive",
    insentiveType: "Incentive Type",
    amount: "Amount",
    selectType: "--Select Type--",
    back: "Back",
    Loading: "Loading....",
    selectconfiguration: "Select Configuration",

    /*  Business Development/Marketing Property */
    addnewpropertynext: "Add Property Next",
    BusinessDM: "Business Development/Marketing",
    locality: "Locality",
    reraPossession: "RERA Possession Date",
    expectedPossession: "Expected Possession Date",
    landparcel: "Land Parcel",
    units: "--Units--",
    towers: "Towers",
    selectTowers: "--Select Towers--",
    typology: "Typology",
    google: "Google",
    instagram: "Instagram",
    facebook: "Facebook",
    taboola: "Taboola",
    timesquare: "Time Square",
    reraCarpet: "RERA Carpet",
    builtUpArea: "Built Up Area",
    salabelArea: "Saleble Area",
    allInclusive: "All Inclusive",
    paymentScheme: "Payment Scheme",
    stage: "--Select Stage--",
    tentativeClosingPrice: "Tentative Closing Price",
    currentStage: "Current Stage ",
    Positive: "Positive",
    Negative: "Negative",
    supportsForCP: "Supports For CP",
    upcomingInfrastructure: "Upcoming Infrastructure of the location",

    /* BusinessDM */
    MarketingAI: "Marketing Assistance Information",
    MarketingBD: "Marketing/Business Development",
    hoardings: "Hoardings",
    newspaper: "Newspaper",
    fromdate: "From Date",
    toDate: "To Date",
    digitalMarketing: "Digital Marketing",
    whatsappSMS: "Whatsapp/SMS",
    blastRadioJingles: "BlastRadio Jingles",
    /*  */
    residentLocation: "Resident Location",
    officeLocation: "Office Location",
    occupation: "Occupation",
    customerDesignation: "Customer Designation (For Service/Salaried Person)",
    AnnualIncome: "Annual Income",
    ethnicity: "Ethnicity",
    ageGroup: "Age Group",
    rentedOwned: "Current Stay (Rented/Owned)",
    currentStayConfiguration: "Current Stay Configuration",
    customerBudget: "Customer Budget",
    preferredTypology: "Preferred Typology",
    purposeofPurchase: "Purpose of Purchase",
    possessionexpected: "Possession expected Date",

    /* BusinessDMend */

    //form error.
    locationErr: "Locality is required.",
    property_titleErr: "Project Name is required.",
    startDateErr: "Start date is required.",
    locationAreaErr: "Location area is required.",
    validLocationErr: "Please enter valid location area.",
    endDateErr: "End date is required.",
    typeOfPropertyErr: "Type of property is required.",
    jwIDErr: "JW Project id is required.",
    configurationErr: "Is required.",
    areaconfErr: "Is required.",
    minErr: "Is required.",
    maxErr: "Is required.",
    inventryErr: "Is required.",
    remainingErr: "Is required.",
    inventryError: "Please enter valid inventry.",
    remainingError: "Please enter valid remaining.",
    propertyImgErr: "Image is required.",
    propertynameErr: "Property name is required.",
    leadfollowupErr: "Lead followup is required.",
    propertyAllocationErr: "Property Allocation is required.",
    selectRoleErr: "Role is required.",
    selectUserErr: "User is required.",
    selectManagerErr: "Manager is required.",
    insentiveErr: "Incentive is required.",
    amountErr: "Amount is required.",
    validAmount: "Please enter valid amount.",

    // View Property

    propertyDetails: "PROPERTY DETAILS",
    viewPropertyDetails: "View Property Details",
    propertyName: "Property Name",
    propertyType: "Property Type",
    maritalStatus: "Marital Status",
    selectMaritalStatus: "--Select Marital Status--",
    familyMember: "Family Member",
    currentStay: "Current Stay",
    currentStayselect: "--Select Current Stay--",
    content: "Contents",
    images: "Images",
    videos: "Videos",
    catalogue: "Catalogue",
    browserNotSupport: "Your browser does not support the video tag.",
    pickupAllowed: "Pickup Facility",
    allocated: "Allocated :",
    RentedOwned: `Current Stay (Rented/Owned)`,
    CurrentStayConfiguration: "Current Stay Configuration",
    CustomerBudget: "Customer Budget",
    PreferredTypology: "Preferred Typology",
    PurposeofPurchase: "Purpose of Purchase",
    Possessionexpected: "Possession expected",
    youWantDelete: "You want to delete this",
    delete: "Delete",
    imageItem: " image",
    videoItem: "video",
    docItem: "document file",

    // Edit Property
    editproperty: "EDIT PROPERTY",

    // Deactive Property
    activeThisProperty: "Activate this property?",
    deactiveThisProp: "Deactivate this property?",

    // Gallery

    gallery: "Gallery",

    //  Role
    Role: "ROLE",
    roleListing: "Role Listing",
    addNewrole: "Add New Role",
    listOfRole: "LIST OF ROLE'S",
    roles: "Roles",
    edit: "Edit",

    // Add New Role
    addNewRole: "ADD NEW ROLE",
    addnewrole: "Add New Role",
    roleName: "Role Name",
    modules: "Modules",
    parent: "Parent",
    subParent: "Sub Parent",

    // Edit Role
    edtiRole: "EDIT ROLE",
    editrole: "Edit Role",

    //form error
    rolename: "Role Name is required.",

    // Module

    module: "MODULE",
    moduleListing: "Module Listing",
    addNewModule: "Add New Module",
    listOfModule: "LIST OF MODULE'S",

    // Add New Module
    moduleName: "Module Name",
    slug: "Slug",
    sequence: "Sequence Number",
    searchmoduleName: "Search By Module Name",
    parentOptional: "Parent(Optional)",
    searchparentOptional: "Search By Parent",
    selectParent: "--Type Parent Name--",

    // Module_Err
    modulenameisrequired: "Module name is required.",
    sequenceisrequired: "Sequence number is required.",

    // Edit Module
    editModule: "Edit Module",

    // Support Forum_index
    supportForum: "SUPPORT FORUM",
    supportForumList: "Support Forum Listing",
    searchLocation: "Search Location",
    searchByTitle: "Search By Title",
    searchTitle: "Search Title",
    searchByDescription: "Search By Description",
    searchDescription: "Search Description",
    addNewSupportForum: "Add New Support Forum",
    listOfSupportForum: "LIST OF SUPPORT FORUM'S",
    title: "Title",
    description: "Description",
    viewSupportForum: "View Support Forum",
    editsupportforum: "Edit Support Forum",
    deactiveSupportForum: "Deactive Support Forum",
    activeSupportForum: "Active Support Forum",

    // Add New Support Forum
    addNewsupportforum: "ADD NEW SUPPORT FORUM",
    addnewsupportforum: "Add New Support Forum",
    video: "Videos",

    // View Support Forum
    supportForumdDetails: "SUPPORT FORUM DETAILS",
    viewsupportforumdetails: "View Support Forum Details",
    supportforumdetails: "SUPPORT FORUM DETAILS",

    // Edit Support Forum
    editsupportForum: "EDIT SUPPORT FORUM",
    editSupportForum: "EDIT SUPPORT FORUM",

    // Deactive Suppot Forum
    activeThisSupportForm: "Active This Support Forum !",
    deactiveThis: "Deactive This Support Forum !",

    // SupportForum Err
    titleErr: "Title is required.",
    locationerr: "Location is required.",
    validLctionErr: "Please select valid location.",
    descErr: "Description is required.",
    videoErr: "Video is required.",

    // Master
    master: "MASTER",
    masterListing: "Master Listing",
    addNewMaster: "Add New Master",
    listOfMaster: "LIST OF MASTER'S",

    // Add New Master
    typeOfMaster: "Type Of Master",
    selectstatus: "--Select Status--",
    active: "Active",
    inactive: "Inactive",
    propertyConfiguration: "Property Configuration",
    propertyAmenity: "Property Amenity",
    followupStatus: "Followup Status",
    propertyUnsubscribeResion: "Property Unsubscribe Reason",
    leadCancle: "Lead Cancel",
    appointmentType: "Appointment Type",
    unitType: "Unit Type",
    leadSource: "Lead Source",
    PaymentType: "Payment Type",
    SupportType: "Support Type",
    cluster: "Cluster",
    cpType: "CP Type",
    selectCpType: "Select Cp Type",
    nameOfCp: "Name of CP",
    mobileNumber: "Mobile Number",
    cpEmailAddress: "Email Address",
    ethniCity: "Ethnicity",

    //Master_Err
    titleisrequired: "Title is required.",

    // Agency(CP)_index
    channelPartner: "Channel Partner",
    channelPartnerListing: "Channel Partner Listing",
    listOfChannelPartner: "Channel partners",
    channelPartnerListSubtitle:
      "Filter and manage agency channel partners, approvals, and allocations.",
    visits: "Visits",
    cpName: "CP Name",
    channelPartnerName: "Channel Partner Name",
    rowsPerPage: "Rows per page",
    allocateProperty: "Allocate Property",
    allocatePropertyHint: "Search and tick every active project this partner should work on.",
    selectAllVisible: "Select all",
    clearSelected: "Clear",
    projectsFound: "projects",
    noProjectsSelected: "No projects selected.",
    noProjectsMatchSearch: "No projects match this search.",
    selectedCount: "selected",
    selectedProperties: "Selected Properties",
    allocatedProperties: "Allocated Properties",
    noPropertiesSelected: "No properties selected.",
    deactivate: "Deactivate",
    activate: "Activate",
    confirmAction: "Confirm Action",
    confirmApproval: "Confirm Approval",
    confirmApproveAgent: "Are you sure you want to approve this agent?",
    confirmCpStatusChange: "Are you sure you want to",
    theChannelPartner: "the channel partner?",
    agentName: "Agent Name",
    agentCode: "Agent Code",
    noOfsiteList: "No. of Site List",
    property_name: "Property Name",
    noOfClosingLead: "Total Closer Visit",
    closingPercentage: "Closing Percentage",
    approved: "Approval",
    viewChannelPartner: "View Channel Partner",
    addNewCP: "Add New Channel Partner",
    editCp: "Edit Channel Partner",
    lastLogin: "Last Login",
    lastLeadCreate: "Last Lead Create",
    lastSiteVisit: "Last Site Visit",
    lastCloseVisit: "Last Close Visit",
    reraStartDate: "Rera start date",
    reraEndDate: "Rera end date",
    approveNewCp: "Approve new CP",
    allocateCpToSm: "Allocate CP To Sm",
    reraNo: "RERA No",
    noOfBookings: "No. of Booking",
    createdDateTime: "Created Date & Time",
    reraCertificateNo: "Rera Certificate No",
    AllocatedProjecbookingCount: "Booking Count",
    AllocatedProjecVisitorCount: "Visitors Count",
    AllocatedProjecWalkInCount: "Walk In Count",

    // Agent_List
    cpAgnet: "CP Agent",
    agentListing: "CP Agent Listing",
    listOfAgent: "LIST OF CP Agent",
    agentDetail: "CP AGENT DETAILS",
    viewAgent: "View CP Agent Details",

    // View Channel Partner
    channelPartnerDetail: "CHANNEL PARTNER DETAILS",
    companyDetals: "COMPANY DETAILS",
    viewchannelpartner: "View Channel Partner Details",
    channelPartnerDetails: "CHANNEL PARTNER DETAILS",
    channelBankDetails: "BANK DETAILS",
    stats: "Stats",
    cpAgentDetails: "CP Agent List",
    agencyInfo: "Agency Info.",
    cpBankDetail: "CHANNEL PARTNER BANKING DETAILS",
    agentBankDetail: "CP AGENT BANKING DETAILS",
    agencyBankDetail: "COMPANY BANKING DETAILS",
    bankName: "Bank Name",
    branchName: "Branch Name",
    accountNo: "Account Number",
    ifscCode: "IFSC Code",
    noOfAgent: "Total Agent :",
    createDate: "Create Date",
    activeBy: "Active By",
    noOfSiteVisit: "Total Site Visit",
    cpProfile: "Profile",
    agencyName: "Agency Name",
    ownerName: "Name of CP",
    aadharNo: "Aadhaar Number",
    aadharNoExample: "EX:- 1234 1234 1234",
    gst: "GST Number",
    companyGST: "Company GST Number",
    reraRegistration: "Company RERA No.",
    companyMailID: "Company Email Id",
    cpMailID: "CP Email Id",
    companyAddress: "Company Address",
    reraCertificate: "Channel Partner RERA Certificate",
    companyReraCertificate: "Company RERA Certificate",
    pan: "PAN",
    email: "Email",
    whatsappNo: "Whats'app Number",
    sourcingManager: "Sourcing Manager",
    closingManager: "Closing Manager",
    workingLocation: "Working Location",
    verifyCP: "Verify Channel Partner",
    youWantVerifyCP: "You want to verify this Channel partner !",

    // Add_CP
    realStateCompany: "Company Name",
    panNumber: "Pancard Number",
    propDeclarLetter: "Proprietorship Declaration Latter",
    reraCertiNumber: "Channel Partner RERA No.",
    bankDetailUser: "Channel Partner Bank Details",
    cancelCheaque: "Cancel Cheaque",
    companyInformation: "Company Information",
    pancard: "Company Pancard",
    companyDeclarLetter: "Declaration Latter of Company",
    bankDetailCompany: "Company Bank Details",
    selectSM: "-- Select Sourcing Mananger --",
    worklocationerr: "Working location is required.",
    individual: "Individual",
    company: "Company",
    applicableforGST: "Are you applicable for GST - Yes or No",
    addNewEmp: "Add New Employee",
    empName: "Employee Name",
    empMobile: "Employee Mobile No.",
    companyMobile: "Company Mobile No.",
    empEmail: "Employee Email",
    employee: "Employee",
    removeEmp: "Remove Employee",
    chooseFile: "Choose file",
    reraValidationMsg:
      "MAHA RERA - (eg: A12345678901) \nUP RERA - (eg: UPRERAABC12345678)",
    allocatepropertytocp: "Please allocate property to cp",

    // channel_partner_form_err
    owner_Err: "Channel Partner name is required.",
    rera_Number_Err: "RERA certificate number is required.",
    company_rera_Number_Err: "Company RERA certificate number is required.",
    validCertificateNo: "Please enter valid RERA certificate number.",
    rera_Certificate_Err: "RERA certificate is required.",
    prop_delcare_Err: "Proprietorship declaration letter is required.",
    bank_Name_Err: "Bank name is required.",
    branch_Name_Err: "Branch name is required.",
    account_number_Err: "Account Number is required.",
    account_valid_Err: "Please enter valid account number.",
    ifsc_Err: "IFSC code is required.",
    ifsc_valid_Err: "Please enter valid IFSC code.",
    cancel_cheaque: "Cancel cheaque is required.",
    agency_Err: "Company name is required.",
    gst_Err: "GST number is required.",
    gst_Valid_Err: "Please enter valid GST number.",
    rera_register_Err: "Company RERA No. is required.",
    validReraRegister: "Please enter valid RERA registration.",
    company_pan_Err: "Pancard is required.",
    company_letter_Err: "Company declaration letter is required.",
    companyAddressErr: "Company Address is required.",
    employee_Err: "Employee is required.",
    empNameErr: "Employee name is required.",
    empMobileErr: "Employee mobile no. is required.",
    empEmailErr: "Employee email is required.",
    pincodeErr: "Please enter valid pincode",

    //  Visitor_index
    visitor: "Visitor",
    visitorList: "Visitor Listing",
    visitorListSubtitle:
      "Filter and review leads by date, status, and property. Sort by newest or visiting score.",
    searchByVisitorName: "Search By Visitor Name",
    searchVisitorName: "Search Visitor Name",
    searchByConfiguration: "Search By Configuration",
    searchByPropertyName: "Search By Property Name",
    selectConfiguration: "--Select Configuration--",
    searchByVistingScore: "Search By Visiting Score",
    selectVisitingScore: "--Select Visiting Score--",
    howToligh: "Low To High",
    highTolow: "High To Low",
    listOfVisitor: "LIST OF VISITOR'S",
    visitorName: "Visitor Name",
    sourceName: "Source Name",
    budget: "Budget",
    viewVisitor: "View Visitor",
    editVisitor: "Edit Visitor",
    updateDraftVisitor: "Update Visitor Draft",
    visitScore: "Visiting Score",
    cpLeadType: "CP Lead Type",
    selectLeadType: "Select Lead Type",
    teleCalling: "Tele-calling",
    direct: "Direct",
    searchByMobileNumber: "Search By Mobile Number",
    searchMobileNumber: "Search Mobile Number",
    walk_in: " Walk-in",
    searchByVistingType: "Search By Visiting Type",
    selectVisitingType: "--Select Visiting Type--",
    visitors: "Visitors",
    draftVisitors: "Draft Visitors",
    selectByPropertyName: "Select By Property Name",
    visitingWith: "Visiting With",
    selectEthnicity: "--Select Ethnicity--",
    expectedPossessionPeriode: "Expected Possession",
    selectExpectedPossession: "-- Select Expected Possession--",
    budgetAmount: "Budget Amount",
    selectBudgetAmount: "-- Select Budget Amount--",

    // View Visitor Details
    visitorDetails: "Visitor Details",
    viewvisitordetails: "View Visitor Details",
    lastInteracted: "Last Interacted :",
    source: "Source",
    propertyRequired: "PROPERTY REQUIRED",
    Area: "Area (in sq.ft)",
    natureOfFunding: "Nature of Funding :",
    purpose: "Purpose :",
    customerDetails: "CUSTOMER DETAILS",
    companyDetails: "COMPANY DETAILS",
    nameOfOccupation: "Occupation :",
    companyName: "Company Name",
    designation: "Designation :",
    officeAddress: "Office Address :",
    houseNo: "House No",
    officeArea: "Area",
    landmark: "Landmark",
    pincode: "Pincode",
    statusUpdate: "Status Update",
    scheduleSiteVisit: "Schedule Site Visit",
    visitorStatusUpdateHint:
      "For follow-up, revisit, and closing updates.",
    openAppointmentManagement: "Appointment Management",
    emname: "Emp. Name",
    createdByRole: "Created By Role",
    created: "Created",

    // Edit Visitor
    editvisitor: "EDIT VISITOR",
    updatedraftvisitor: "UPDATE VISITOR DRAFT",
    visitorListing: "Visitor Listing",
    expectedPossesionDate: "Expected Possesion Date",
    minBudget: "Min Budget",
    maxBudget: "Max Budget",
    natureOffunding: "Nature of Funding",
    loan: "Loan",
    selfFunding: "Self Funding",
    both: "Both",
    Purpose: "Purpose",
    endUser: "End User",
    invesment: "Investment",
    preferredBank: "Preferred Bank",
    visitorFirstName: "Visitor First Name",
    visitorFullName: "Visitor Full Name",
    visitorLastName: "Visitor Last Name",
    pancardNo: "Pancard Number",
    panNumberExample: "ex:- BNZAA2318M",
    dateofBirth: "Date of Birth",
    salaried: "Salaried",
    minEMIpay: "Min EMI Pay",
    maxEMIpay: "Max EMI Pay",
    selfEmployed: "Self Employed",
    professional: "Professional",
    desigantion: "Designation",
    officeaddress: "Office Address",
    married: "Married",
    unmarried: "Unmarried",
    rented: "Rented",
    owned: "Owned",
    moveIn: "Move In",
    underConstruction: " Under Construction",
    viaIndividual: "Via Individual CP",
    viaCompany: "Via CP Company",
    chooseCP: "Select CP",
    cpCompany: "CP Company Name",
    selectCpCompany: "Select CP Company Name",
    companyEmployName: "Company Employee name",
    selectEmployeeName: "Select Employee name",
    cpEmployeeName: "CP Employee name",
    createAndSchedule: "Create and Schedule",
    family: "Family",
    couple: "Couple",
    friend: "Friend",
    single: "Single",
    business: "Business",
    homeMaker: "Home Maker",
    retired: "Retired",
    others: "Others",
    workLocation: "Work Location",
    leadStatus: "Lead Status",
    leadPriority: "Lead Priority",
    qualified: "Qualified",
    unQualified: "Unqualified",
    hot: "Hot",
    warm: "Warm",
    cold: "Cold",
    selectLeadStatus: "Select Lead Status",
    selectLeadPriority: "Select Lead Priority",

    three_to_six_month: "3 – 6 Months",
    six_to_one_year: "6 Months – 1 Year",
    one_year_to_two_year: "1 – 2 Years",
    two_year_and_above: "2 Years and Above",

    below_50_lakhs: "Below - 50L",
    fifty_lakhs_to_seventy_five_lakhs: "50L - 75L",
    seventy_five_lakhs_to_one_crore: "75L - 1Cr",
    one_crore_to_1_30_crore: "1Cr - 1.30Cr",
    one_31_crore_to_1_50_crore: "1.31Cr - 1.50Cr",
    one_51_crore_to_1_75_crore: "1.51Cr - 1.75Cr",
    one_76_crore_to_2_crore: "1.76Cr - 2Cr",
    two_crore_to_2_5_crore: "2Cr - 2.5Cr",
    above_2_5_crore: "2.5Cr and above",

    // Edit Visitor_Error
    configuration_Err: "Configuration is required.",
    expected_possession_date_Err: "Expected possession date is required.",
    areain_sqlft_Err: "Area (in sq.ft) is required.",
    areain_sqlft_Nan_Err: "Enter only number.",
    firstName_Err: "Visitor name is required.",
    birthDate_Err: "Birth date is required.",
    mobile_Err: "Mobile number is required.",
    location_Err: "Location is required.",
    desigantion_Err: "Designation is required.",
    officeAddress_Err: "Office address is required.",
    budget_Err: "Please enter valid budget.",
    adhar_no_Err: "Aadhaar number is required.",
    validAadhar_Err: "Please enter valid aadhaar number.",
    pancard_no_Err: "Pancard number is required.",
    validPancard_Err: "Please enter valid pancard number.",
    purposeErr: "Purpose is required.",
    fundingErr: "Funding Type is required.",
    occupationErr: "Occupation is required.",
    annualHouseholdIncome: "Annual Household Income",
    selectAnnualHouseholdIncome: "Select Annual Household Income",
    annualHouseholdIncomeErr: "Annual household income is required.",

    // Visitor_popup_modal
    useOldData: "Use Old Data",
    createNew: "Create New",
    conformation: "Confirmation",
    checkMobileNumber: "Please check entered mobile number",
    mobileNoWithoutCountryCodeHint:
      "Enter mobile number without country code (+91).",
    mobilePlaceholderGre: "10-digit mobile number",
    mobileOtpEnterValid: "Enter a valid 10-digit mobile number to send OTP",
    mobileOtpChangeNumber: "Change number",
    otpCardSubtitle: "We've sent a 4-digit code to",
    otpDidntReceive: "Didn't receive the code?",
    sendOtpToVerify: "Verify Mobile Number",
    otpSent: "OTP Sent",
    enterOtpSentTo: "Enter the 4-digit OTP sent to",
    verifyOtp: "Verify OTP",
    mobileVerifiedSuccess: "Mobile number verified",
    verifyMobileWithOtp: "Please verify mobile number with OTP",
    clearOtp: "Clear OTP",
    otpSentSuccess: "OTP sent successfully",
    otpResentSuccess: "OTP resent successfully",
    otpVerifySuccess: "Phone number verified successfully",
    otpSendFailed:
      "OTP SMS could not be sent. Please contact your administrator.",
    otpVerifyFailed: "Failed to verify OTP",
    otpInvalid: "Invalid OTP. Please try again.",
    otpEnterFourDigits: "Please enter 4-digit OTP",
    mdocSyncSuccessTitle: "M-Doc",
    mdocSyncSuccessMessage: "Lead synced to M-Doc successfully.",
    mdocSyncFailedTitle: "M-Doc sync failed",
    mdocSyncFailedMessage:
      "Could not sync lead to M-Doc. Please try again or contact support.",
    mdocSyncDryRunTitle: "M-Doc (test mode)",
    mdocSyncDryRunMessage: "Lead recorded for M-Doc sync (test mode).",
    mdocSyncValidationFailedMessage:
      "Lead data is incomplete for M-Doc sync. Please check required fields.",
    mdocEmailRequiredForProperty:
      "Email is required for this property to sync with M-Doc.",

    // Appointment
    appointment: "APPOINTMENT",
    appointmentManagement: "Appointment management",
    appointmentList: "Appointment Listing",
    appointmentListSubtitle:
      "Filter site visits by date, status, and lead details. View history for repeat visits.",
    appointmentWith: "Appointment with",
    appointWith: "--Appointment with--",
    siteLeadVisit: "Site Lead Visit",
    clientVisit: "Client Visit",
    searchByCustomerName: "Search By Customer Name",
    searchCustomerName: "Search Customer Name",
    searchByStatus: "Search By Status",
    panding: "Pending",
    readyToBook: "Ready To Book",
    confirm: "Confirm",
    complete: "Complete",
    searchPropertyName: "Search Property Name",
    listofappointment: "LIST OF APPOINTMENT'S",
    siteVisitTimeDate: "Site Visit Date & Time",
    siteRevisitVisitTimeDate: "Revisit Visit Date & Time",
    customerName: "Customer Name",
    visitingScore: "Visiting Score",
    upcoming: "Upcoming",
    visitStatus: "Visit Status",
    bookingreadytobook: "Booking/Ready to Book",
    revisit: "Revisit",
    visitcancelled: "Visit Cancelled",
    notfitforseal: "Not Fit for Sale",
    actualvisit: "Actual Visits",
    allAppointment: "All Appointments",
    todayAppointments: "Today's appointments",
    todayAppointmentsSubtitle:
      "Revisits and site visits scheduled for today.",

    // View Appointment
    viewAppointmentDetails: "APPOINTMENT DETAILS",
    viewappointmentdetails: "View Appointment Details",
    appointmentDetails: "APPOINTMENT DETAILS",
    whenToBuy: "When to buy :",
    property: "Property",
    pickupLocation: "Pickup Location :",
    dropLocation: "Dropup Location :",
    noOfGuest: "No. of Guest :",
    reason: "Reason",
    closingStatus: "Closing Status",
    checkInStatus: "Check in status",
    notInterested: "Not Interested",
    bookNow: "Book Now",
    followUp: "Follow-up",
    noShow: "No Show",
    noShowTitle: "Mark as No Show",
    noShowSubtitle:
      "Choose Rescheduled or Appointment Cancel, then add a description.",
    noShowConfirm: "Update Appointment",
    noShowStatusRequired: "Please select a status",
    noShowDateRequired: "Please select a date",
    noShowTimeRequired: "Please select a time",
    noShowDescriptionLabel: "Description",
    noShowDescriptionPlaceholder: "Enter a description",
    noShowDescriptionRequired: "Please enter a description",
    notInterestedTitle: "Mark as Not Interested",
    notInterestedSubtitle:
      "Choose a reason and add a short remark before closing this visit.",
    notInterestedConfirm: "Confirm Not Interested",
    closingRemarkLabel: "Remark",
    closingRemarkPlaceholder: "Enter a remark",
    closingRemarkRequired: "Please enter a remark",
    visitorCheckin: "Visitor Check-in",
    confirmCheckin: "Check this visitor in for the site visit?",
    confirmCheckinTitle: "Confirm check-in",
    closingStatusBackWarningTitle: "Closing status not updated",
    closingStatusBackWarningBody:
      "Going back will not add this visit or revisit details to the disposition report. Use Book Now, Not Interested, Follow-up, or Revisit to update the closing status first.",
    stayOnThisScreen: "Stay",
    goBackWithoutClosingStatus: "Go Back",
    lowVisitorScoreTitle: "Low visitor score",
    lowVisitorScoreMessage:
      "Visitor score is below 70. Please update the visitor details before booking.",
    selectReason: "Select Reason",
    assignTo: "Assign To",
    allocate: "Allocate",
    allocateToCM: "Allocate to CM",
    allocatedToCM: "Allocated to CM",
    alreadyAllocated: "Already allocated",
    currentlyAllocatedTo: "Currently allocated to",
    reassignToCM: "Reassign",
    cmClearSelection: "Clear",
    notAllocatedToCM: "Not allocated",
    reAllocateToCM: "Re-Allocate",
    reassignVisitorToCM: "Reassign Visitor to Closing Manager",
    allocateVisitorToCM: "Allocate Visitor to Closing Manager",
    reAllocateVisitorToCM: "Re-Allocate Visitor to Closing Manager",
    selectNewClosingManager: "Select New Closing Manager",
    updateVisitordetails: "Update Visitor Details",
    viewVisitorHistory: "View Visitor History",

    // Edit Appointment
    editAppointment: "EDIT APPOINTMENT",
    EditAppointment: "Edit Appointment",
    selectLead: "Select Lead",
    selectlead: "--Select Lead--",
    selectProperty: "Select Property",
    selectproperty: "--Select Property--",
    AppointmentDate: "Appointment Date",
    AppointmentTime: "Appointment Time",
    AppointmentTimeDetail: "Select a time between 10:00 AM and 7:00 PM.",
    addAppointmentSubtitle: "Set the visitor, property, and site visit schedule.",
    revisitAppointmentSubtitle: "Choose the next site visit date and time.",
    revisitRemarkRequired: "Please enter a remark for this revisit.",
    revisitRemarkMinLength: "Remark must be at least 20 characters.",
    revisitRemarkHint: "Minimum 20 characters.",
    selectAppointmentDate: "Select date",
    Pickup: "Pickup(if add property time set yes)",
    pickuplocation: "Pickup Location",
    numberofGuest: "Number of Guest",
    pickupLocationErr: "Pickup Location is required.",
    numberOfGuest: "Number of guest is required.",
    validNumber: "Please enter a valid number.",
    rescheduled: "Rescheduled",
    appointmentCancel: "Appointment Cancel",

    // Add Appointment
    addAppointment: "Add New Appointment",
    pickup: "Pickup",
    leadErr: "Lead is required.",
    ValidTimeErr: "Select a time between 10:00 AM and 7:00 PM.",
    validTime: "Please select a time.",

    //  New Upload
    newupload: "NEW UPLOAD",
    newuploadListing: "New Upload Listing",
    searchByname: "Search By Name",
    listofnewupload: "LIST OF NEWUPLOAD'S",
    cpname: "CP Name",
    noOfVisitor: "Total Visitor",
    closingLead: "Closing Lead",
    visitorScore: "Visitor Score",
    createVisitor: "Create Visitor",

    // Verify Lead
    VerifyVisitor: "Verify Visitor",
    verifyListing: "Verify Visitor Listing",
    listOfVerifyVisitor: "List Of Verify Visitor",
    urgency: "Urgency",
    searchByRole: "Search By Role",
    viewVerifyLead: "View Verify Lead",
    addVerifyLead: "Add Verify Lead",
    viewVerifyVisitor: "View Verify Visitor Details",

    // Error
    customerName_Err: "Visitor name is required.",

    // Create Visitor
    createvisitor: "CREATE VISITOR",
    CreateVisitor: "Create Visitor",
    propertyname: "Property Name",
    addNewVisitor: "Add New Visitor",

    // Bulk Upload
    bulkUpload: "Bulk Upload",
    imageUpload: "Image Upload",
    csvUpload: "CSV Upload",
    upload: "Upload",
    csv: "CSV File",
    csvFile: "CSV File is required.",
    downloadCsvFile: "Download CSV Sample",

    // Followup_index
    followup: "Followup",
    followupList: "Followup Listing",
    todayFollowupList: "Today Followup Listing",
    listOfFollowup: "LIST OF FOLLOWUP'S",
    listOfTodayFollowup: "LIST OF TODAY FOLLOWUP'S",
    followupDate: "Date",
    followupDateTime: "Next Followup D & T",
    vistiorName: "Visitor Name",
    followType: "Follow Type",
    lead: "Lead",
    leadType: "Lead Type",
    siteVisit: "Appointment",
    booking: "Booking",
    registration: "Registration",
    viewfollowup: "View Followup ",
    EditFollowup: "Edit Followup",
    viewallfollowUp: "View All Followup",
    viewHistory: "View History",

    // View Followup Details
    viewfollowupDetails: "FOLLOWUP DETAILS",
    viewfollowupdetails: "View Followup Details",
    followupDetails: "FOLLOWUP DETAILS",

    // Edit Followup
    editFollowup: "EDIT FOLLOWUP",

    // Edit Followup ERROR
    followupStatusErr: "Followup status is required.",
    visitStatusErr: "Lead type is required.",
    followup_dateErr: "Date is required.",
    followup_timeErr: "Time is required.",
    remarkErr: "Description is required.",
    appointmentWithErr: "Appointment with is required",
    appointmentTypeErr: "Appointment type is required",

    // All Followup
    allFollowup: "ALL FOLLOWUP",
    allfollowup: "All Followup",
    followupBy: "Followup By",
    date: "Date",

    //Schedule activity followup
    scheduledFollowup: "Scheduled Followup",
    scheduledFollowupList: "Scheduled Followup List",
    scheduledlistOfFollowup: "Scheduled list Of Followup",
    followupRemark: "Remark",
    closingRemark: "Closing Remark",
    closingDateTime: "Closing D & T",
    followUPDateTime: "Followup D & T",
    walkinRemark: "Walk-in Remark",
    walkinRemarkPlaceholder: "Add a short note from the walk-in conversation",
    walkinRemarkErr: "Walk-in remark is required.",
    addVisitorFollowupDate: "Follow-up Date",
    addVisitorFollowupTime: "Follow-up Time",
    dueFollowUps: "Due Followups",
    nextDayCall: "Next Day Call",
    invalidTimeError: "Please select a future time for today.",

    // Update Status Follow
    newFollowup: "NEW FOLLOWUP",
    NewFollowup: "New Followup",
    updateFollowup: "UPDATE FOLLOWUP",
    time: "Time",

    // Chat Screen
    chatScreen: "CHAT SCREEN",
    recentChat: "Recent Chat",
    chat: "Chat",
    typeAmessage: "Type a message......",
    send: "Send",
    userNotSelect: "User not selected.",
    startChat: " Please select user and start chat.",

    // Raise Ticket_index(Support_Ticket)
    raiseTicket: "RAISE TICKET",
    raiseTicketList: "Raise Ticket Listing",
    searchByIssue: "Search By Issue",
    listOfRaiseTicket: "LIST OF RAISE TICKET'S",
    ticket: "Ticket",
    createBy: "Create By",
    closeBy: "Close By",
    remark: "Description",
    updateBy: "Update By",
    updateDate: "Update Date",
    issue: "Issue",
    viewSupportticket: "View Support Ticket",
    updateStatus: "Update Status",
    searchByTicketNo: "Search By Ticket Number",
    selectIssue: "--Select Issue--",
    exportList: "Export",
    propertyTitle: "Property Title",
    supportRequest: "Support Request",
    myTicket: "My Ticket",

    //  View Raise  Ticket Details
    supportticketdetails: "RAISE TICKET DETAILS",
    viewsupportticketdetails: "View Raise Ticket Details",
    supportTicketDetails: "RAISE TICKET DETAILS",
    raiseReply: "Raise Ticket Reply",
    ticketNo: "Ticket No.",
    updateByName: "Updated By",

    // Update Raise Ticket(Support)
    updateSupportticket: "UPDATE RAISE TICKET",
    updatesupportticket: "Update raise Ticket",
    updateSupportTicket: "UPDATE RAISE TICKET",
    editRaiseTicketReply: "Edit Raise Ticket Reply",
    selectStatus: "Select Status",
    open: "Open",
    statusErr: "Status is required.",

    //Add And Edit Raise Ticket
    editRaiseTicket: "Edit Raise Ticket",
    addRaiseTicket: "Add Raise Ticket",
    editTicket: "Edit Ticket",
    addTicket: "Add Ticket",
    issueErr: "Issue is required.",

    // Configuration_Setting
    // email
    configurationSetting: "Configuration Setting",
    configurationEmail: "Configuration Email",
    accessControl: "Access Control",
    accessControlSubtitle: "Choose one task below.",
    accessControlAsk: "What do you want to do?",
    accessControlTaskDefault: "Change default password",
    accessControlTaskDefaultDesc:
      "Template only — does not change anyone’s current login",
    accessControlTaskBulk: "Reset or log out many users",
    accessControlTaskBulkDesc: "Apply to a group of active logins",
    accessControlTaskSingle: "Sign out one user",
    accessControlTaskSingleDesc: "End sessions for one person only",
    accessControlStepDefault: "Default password",
    accessControlStepBulk: "Bulk actions",
    accessControlStepSingle: "Single user",
    accessControlSafeBadge: "Does not sign anyone out",
    accessControlBulkBadge: "Affects many logins",
    accessControlSingleBadge: "One login only",
    accessControlWhoAffected: "Who is affected",
    accessControlBulkActionsLabel: "Actions for this scope",
    affectedLoginsLabel: "People affected",
    forceLogoutOneUser: "Sign out one user",
    forceLogoutOneUserHint: "Find them by name or email.",
    forceLogoutUserSearchLabel: "Search user",
    forceLogoutUserSearchPlaceholder: "Type a name or email…",
    forceLogoutUserRequired: "Please select a user to sign out.",
    forceLogoutOneUserAction: "Sign out",
    accessControlSelectedLabel: "Selected",
    configurationDefaultPassword: "Access Control",
    configurationDefaultPasswordSubtitle: "Choose one task below.",
    changeDefaultPassword: "Change default password",
    changeDefaultPasswordHint:
      "Saves the template used for future resets. It does not change anyone’s current login. To make people use this password, reset them (one user from Users, or bulk reset here).",
    defaultPasswordUsingEnv:
      "Using the system fallback until you save a password here.",
    defaultPassword: "New password",
    confirmDefaultPassword: "Confirm password",
    saveDefaultPassword: "Save",
    defaultPasswordRequired: "Please enter a default password.",
    defaultPasswordMinLength: "Default password must be at least 6 characters.",
    defaultPasswordMismatch: "Passwords do not match.",
    centralPasswordReset: "Reset or log out many users",
    centralPasswordResetHint:
      "Reset passwords only — they stay signed in. Use Sign them out if you want to end their sessions.",
    centralPasswordResetUsesCurrent:
      "Uses the current default password (save above only if you want to change it first).",
    resetScope: "Who",
    resetPropertyOptional: "Property (optional)",
    resetPropertyAllPlaceholder: "All properties",
    resetPropertyHint: "Optional — leave as All properties for everyone in scope.",
    affectedLoginsCount: "People affected: {count}",
    loadingAffectedCount: "Counting…",
    sendPasswordEmail: "Email a reset notice (no password in the email)",
    sendLogoutEmail: "Email a sign-out notice (password is not changed)",
    resetActionTitle: "Reset passwords",
    resetActionHint:
      "Sets the current default password. People stay signed in until you sign them out.",
    resetActionEmail:
      "Email a reset notice. The password is never included in the email.",
    logoutActionTitle: "Sign them out",
    logoutActionHint:
      "Ends their current sessions only. Their password is not changed.",
    logoutActionEmail:
      "Send them an email confirming they have been signed out.",
    forceLogoutEmailPreviewLabel: "Sign-out email preview",
    forceLogoutEmailPreviewSubject: "Subject",
    forceLogoutEmailPreviewSubjectValue:
      "You have been signed out of JustoVerse",
    forceLogoutEmailPreviewGreeting: "Hello {name},",
    forceLogoutEmailPreviewSampleName: "User",
    forceLogoutEmailPreviewBody1:
      "An administrator has signed you out of JustoVerse on all devices.",
    forceLogoutEmailPreviewBody2:
      "Please sign in again to continue. Any session on a phone or computer has ended.",
    forceLogoutEmailPreviewBody3:
      "If you did not expect this, contact JVerse Support at jv.support@justo.co.in or WhatsApp 8652779607.",
    forceLogoutEmailPreviewSignoff: "Team Justo Tech",
    forceLogoutConfirmWithEmail:
      "A sign-out notice will be emailed (password is not included).",
    forceLogoutConfirmNoEmail: "No email will be sent.",
    bulkPeopleLabel: "People in this list",
    bulkPeopleHint:
      "Tick who to include. Reset changes the password only. Sign them out only if you tap that button.",
    bulkPeopleSearchPlaceholder: "Search by name, email, or role…",
    bulkPeopleSelectAll: "Select all",
    bulkPeopleSelectAllCount: "Select all {count}",
    bulkPeopleSelectVisible: "Select these {count}",
    bulkPeopleClear: "Clear selection",
    bulkPeopleToggleVisible: "Select the people shown",
    bulkPeopleSelectedCount: "{selected} of {total} selected",
    bulkPeopleSearchToBrowse:
      "This list has {count} people. Search by name or email, or use Select all.",
    bulkPeopleNoneSelected: "Select at least one person to continue.",
    bulkPeopleEmpty: "No people match this Who and property.",
    bulkPeopleNoSearchMatch: "No names match this search.",
    passwordResetEmailPreviewLabel: "Email preview",
    passwordResetEmailPreviewSubject: "Subject",
    passwordResetEmailPreviewSubjectValue:
      "Your JustoVerse password has been reset",
    passwordResetEmailPreviewGreeting: "Hello {name},",
    passwordResetEmailPreviewSampleName: "User",
    passwordResetEmailPreviewBody1:
      "Your JustoVerse account password has been reset to the system default by an administrator.",
    passwordResetEmailPreviewBody2:
      "For security reasons, login details are not included in this email. Please contact your administrator to receive your updated login credentials.",
    passwordResetEmailPreviewBody3:
      "If you did not expect this change, contact JVerse Support at jv.support@justo.co.in or WhatsApp 8652779607.",
    passwordResetEmailPreviewSignoff: "Team Justo Tech",
    forceLogoutNow: "Sign them out",
    forceLogoutHint:
      "Ends their sessions only. Passwords stay the same.",
    forceLogoutConfirmTitle: "Sign out these users?",
    bulkConfirmPeopleLabel: "Selected people",
    forceLogoutConfirmBody:
      "This will sign out {count} login(s) for “{scope}”{property}. Passwords are not changed.",
    forceLogoutConfirmAction: "Sign out",
    forceLogoutUser: "Force logout",
    forceLogoutUserTitle: "Sign out this user?",
    forceLogoutUserIntro:
      "They will be signed out on all devices. Their password is not changed.",
    forceLogoutUserWarningSession:
      "All active sessions for this user will end. They must sign in again.",
    forceLogoutUserWarningPassword:
      "The password and other account data are not changed.",
    forceLogoutUserConfirmAction: "Sign out",
    loggingOut: "Signing out…",
    forceLogoutAfterReset: "Force logout on all devices after reset",
    resetPasswordsNow: "Reset passwords",
    confirmCentralResetTitle: "Reset these passwords?",
    confirmCentralResetBody:
      "This will reset {count} login(s) for “{scope}”{property} to the current default password. They will stay signed in until you use Sign them out.",
    confirmCentralResetProperty: " on property “{property}”",
    confirmCentralResetAllProperties: " (all properties)",
    confirmCentralResetNoEmail: "No email will be sent.",
    confirmCentralResetWithEmail:
      "A notice email will be sent (no password included).",
    confirmCentralResetForceLogout:
      "Users will be signed out on all devices and must log in again.",
    confirmReset: "Reset passwords",
    resetting: "Resetting…",
    saving: "Saving…",
    smtpKey: "SMTP Key",
    smtpUserId: "SMTP User ID",

    // registraion screeen
    registraionListing: "Registration Listing",
    viewRegistraion: "Registration Details",

    // Booking
    bookingListing: "Booking Listing",
    bookingListSubtitle:
      "Filter and review bookings. Sync pending records to JW when needed.",
    viewBooking: "Booking Details",
    bookingDetailsSubtitle:
      "Review booking information and sync to JW when needed.",
    bookingDetailOverview: "Overview",
    bookingDetailUnit: "Unit",
    bookingDetailPayment: "Payment",
    bookingDetailReference: "Booking reference",
    syncToJw: "Sync to JW",
    syncAllToJw: "Sync all to JW",
    syncAllToJwNone: "All bookings are already synced to JW.",
    syncAllToJwDone: "JW sync finished.",
    jwBookingNo: "JW Booking No",
    jwSyncPending: "Not synced with JW",
    jwSynced: "Booking synced with JW",
    jwSyncPendingShort: "Not synced",
    jwSyncedShort: "Synced with JW",
    jwSyncSuccess: "Booking synced to JW successfully.",
    jwAlreadySynced: "Booking is already synced to JW.",
    confirmListing: "Confirm Listing",
    viewConfirmListing: "View Confirm Booking",

    // Email_Err
    emailValidationErr: "Please enter valid email.",
    useremailErr: "Please enter valid email or username.",
    smtpKey_Err: "Smtp key is required.",
    smtpuserId_Err: "User Id is required.",
    smtpPassword_Err: "Password is required.",

    // massage
    configurationMassage: "Configuration Message",
    accountSID: "Account SID",
    authToken: "Auth Token",
    accountID: "Account ID",

    // massage_Err
    accountSid_Err: "Account SID is required.",
    authToken_Err: "Auth token is required.",
    accountId_Err: "Account Id is required.",

    // notification
    notificationMapKey: "Notification Map Key",
    mapKey: "Map Key (for the google location)",
    fcmKey: "FCM Key (for notification)",

    // notification_Err
    mapKey_Err: "Map Key is required.",
    fcmKey_err: "Fcm Key is required.",

    // publicLead
    publicLead: "Public Lead",
    leadSourceErr: "Lead source is required.",
    forSmIdErr: "Sourcing Manager is required.",
    chanelPartnerType: "Channel Partner type is required.",
    chanelPartnerRequired: "Channel Partner Required",
    propertyRequire: "Property Require",
    companyDetail: "Company Details",
    prop_titleErr: "Please select Property name.",
    selectProp: "--Select Property--",
    selectPropType: "--Select Property Type--",
    close: "Close",
    done: "Done",
    invalidRequest: "Invalid Request",
    amountTypeErr: "Please select amount type.",
    amountEror: "Please enter maximum amount more than minimum amount.",
    amountMaxEror: "Please enter maximum amount.",
    amountMinEror: "Please enter minimum amount.",
    amountMaxEmiEror: "Please enter maximum emi amount.",
    amountMinEmiEror: "Please enter minimum emi amount.",
    fieldRequired: "Please fill in the required fields.",
    missingRequiredFieldsPrefix: "Please fill the following required fields:",
    thankYou: "Thank You!",
    visitSubmitted:
      " Your visit has been submitted. Someone from our team will contact you shortly.",
    remarkField: "Remark",
    selectLeadSource: "--Select Lead Source--",
    leadForSoursingManager: "Lead for Sourcing Manager",
    leadForSmGreHint: "(to be filled by the executive)",
    selectSourcingManager: "--Select Sourcing Manager--",
    sourcingManagerRequired: "Please select a sourcing manager.",
    selectClosingManager: "--Select Closing Manager--",
    selectSM_Manager: "Select Sourcing Manager",
    assignToNewClosingManager: "Assigned to New Closing Manager",

    // ERROR_PAGE
    backHomePage: "BACK TO HOME PAGE",
    unAuthorized: "Unauthorized person, not permitted beyond this point",

    // Call_center_dashboard
    // Privacy Policy
    editPrivacyPolicy: "Edit Privacy Policy",

    // Term And Condition
    editTermAndCondtion: "Edit Term And Condition",

    // Booking_management
    bookingList: "List of Booking's",
    bookingDate: "Booking Date",
    bookingAmount: "Booking Amount",
    currentStatus: "Current Status",
    bookingNumber: "Booking Number",
    bookingBy: "Booking By",
    chequeNumber: "Cheque Number",
    confiQty: "Configuration Qty",
    bookingCancel: "Booking Cancel",
    addBooking: "Add Booking",
    flatUnitTitle: "Flat",
    addMoreFlats: "Add more",
    deleteFlat: "Delete",
    flatName: "Flat Name",
    floors: "Floors",
    attachPhoto: "Attach Photo",
    carpetArea: "Carpet Area",
    agreementValue: "Agreement Value",
    rateAchieved: "Rate Achieved",
    selectFloor: "Select Floor",
    selectFlat: "Select Flat",
    noInventoryLoaded: "Inventory not loaded for this property. Check JW project ID or try again.",
    jwInventoryAccessDenied:
      "JW inventory access denied. Unable to receive inventory data.",
    jwInventoryMissingProject:
      "JW project ID is missing for this property. Inventory cannot be loaded.",
    jwInventoryEmpty:
      "No inventory units received from JW for this property.",
    jwInventoryLoadFailed:
      "Unable to receive inventory data from JW. Please try again.",
    noPhotoSelected: "No photo selected",
    browse: "Browse",
    removePhoto: "Remove",
    viewPhoto: "View Photo",
    comment: "Comment",
    commentErr: "Comment is required. Please enter a description.",
    creditCard: "Credit Card",
    upi: "UPI",
    cheque: "Cheque",
    debitCard: "Debit Card",
    neft: "Neft",
    paymentType: "Payment Type",

    // registration_management
    registraionList: "List of Registration's",
    paymentMode: "Payment Mode",
    leadby: "Lead By",
    registerAmount: "Register Amount",
    registerBy: "Register By",

    // report
    report: "Report Management",
    kpiReport: "KPI Tracker Report Management",
    reportManageList: "Report Manage Listing",
    kpiTrackerList: "KPI Tracker Report Listing",
    reportListing: "Report Listing",
    bySite: "Search By Site",
    selectSite: "--Select Site--",
    byEmployee: "Search By Employee",
    SelectEmployee: "--Select Employee--",
    byCPName: "Search By Channel Partner Name",
    selectCPName: "--Select Channel Partner Name--",
    conversionFunnel: "Conversion Funnel",
    parameters: "Parameters",
    count: "Counts",
    mtd: "MTD",
    Ytd: "YTD",
    LastSevenDays: "Last 7 Days",
    LastThirtyDays: "Last 30 days",
    cpCount: "CP Count :",
    leadCount: "lead Count :",
    bookingCount: "Booking Count :",
    TotalCPMapRegisteredtillDate: "Total Maped CP :",
    NewCPRegisteredFTM: "New CP Registered :",
    TotalNewCPRegisteredFTM: "Total CP Registered :",
    BookingDone: "Booking Done :",
    TotalBookingDone: "Total Booking Done :",
    VisitorsEntry: "Visitors Entry :",
    TotalVisitorsEntry: "Total Visitors Entry :",
    leads: "Leads",
    SiteVisitCreated: "Site Visit Created",
    WalkIns: "Walk-ins",
    reportUser: "Report",
    todayReport: "Today Report",

    SiteVisitCreate: "Site Visit Create :",
    TotalSiteVisitCreate: "Total Site Visit Create :",
    ActualVisit: "Actual Visit :",
    TotalActualVisit: "Total Actual Visit :",
    Revisit: "Revisit :",
    TotalRevisit: "Total Revisit :",
    CustomerLost: "Customer Lost :",
    TotalCustomerLost: "Total Customer Lost :",
    Noshowvisit: "No Show Visit :",
    TotalNoshowvisit: "Total No Show Visit :",
    ReportBookingCancel: "Booking Cancel :",
    TotalReportBookingCancel: "Total Booking Cancel :",
    checkin: "Checkin :",
    totalCheckins: "Total Checkins :",

    // Report_Management
    totalCountForall: "Total counts for all projects",
    totalUser: "Total Employees",
    activeEmp: "Active Employees",
    deactiveEmp: "Deactive Employees",
    listTotalUser: "List of total Employees",
    listActiveUser: "List of active Employees",
    listDectiveUser: "List of deactive Employees",
    searchByModuleName: "Search By Module Name",
    searchByUserName: "Search By User Name",
    UserActivityList: "User Activity Report",
    userName: "User Name",
    access: "Access Module",
    ftd: "FTD",

    // Web_Report
    roleWiseReport: "Role Wise Report",
    rolewiseProject: "Project Roll wise data",
    roleswiseAllProject: "All project Roll wise data",
    projectDetailsReport: "Project Details Report",
    allProjectDetails: "All project data",
    siteVisits: "Site Visits",
    bookings: "Bookings",
    onDate: "On Date",
    allProjects: "All Projects",
    submitted: "Submitted",
    reVisits: "Site Revisits",

    // followupStatus: "Follow up Status",
    LeadQuality: "Lead Quality",
    teamPerformance: "Team Performance",
    teamCPPerformance: "CP Performance",
    fifty: "<50",
    fifityseventy: "50-70",
    seventyplus: "70+",
    total: "Total",
    department: "Department",
    teamMemberName: "Team Member Name",
    visitorsActual: "Visitors (Actual)",
    bookingsActual: "Bookings (Actual)",

    // Support_Contact_us
    constactUs: "Contact Us",
    headOffice: "HEAD OFFICE",
    phone: "Phone",
    website: "Website",

    // User Announcement
    userAnnouncement: "User Announcement",
    sendTo: "Send To",
    justoUser: "Justo User",
    message: "Message",
    select: "Select",
    selectedUser: "Selected User",
    allUser: "All User",
    selectCP: "Selected Channel Partner",
    allCp: "All Channel Partner",
    sendToErr: "Please select user or channel partner.",
    selectcpErr: "Channel partner is required.",
    messageErr: "Message is required.",
    propertyErr: "Please select property.",

    //newdash
    channelPartners: "Channel Partners",
    appointments: "Appoinments",
    customers: "Customers",

    //deposit report
    depositionReport: "Disposition Report",
    visitType: "Visit Type",
    selectVisitType: "Select Visit Type",
    freshVisit: "Fresh",
    depositionVisitorSearchHint:
      "Searching by visitor name or mobile finds all matching visits. Leave dates as today, or set a custom range to narrow results.",
    latestLeadStatus: "Latest Lead Status",
    selectLatestLeadStatus: "Select lead status",
    sortOrder: "Sort Order",
    sortBy: "Sort By",
    sortLatestFirst: "Latest First",
    sortOldestFirst: "Oldest First",
    recentlyAddedNewest: "Recently Added (Newest First)",
    visitingScoreHighToLow: "Visiting Score (High → Low)",
    visitingScoreLowToHigh: "Visiting Score (Low → High)",
    visitorStatusFilter: "Visitor Status",
    selectVisitorStatus: "Select Visitor Status",

    // MDoc audit log
    mdocAuditLog: "MDoc Audit Log",
    mdocProperty: "MDoc Property",
    timestamp: "Timestamp",
    visitorId: "Visitor ID",
    eventTrigger: "Event / Trigger",
    syncStatus: "Sync Status",
    requestPayload: "Request Payload",
    responsePayload: "Response Payload",
    httpStatusCode: "HTTP Status",
    errorMessage: "Error Message",
    retry: "Retry",
    retryMdocSync: "Retry M-Doc sync",
    editAndRetry: "Edit & Retry",
    saveAndRetry: "Save & Retry",
    capturedBy: "Captured By",
    retryMdocSyncConfirm:
      "Update any missing visitor details, save them, then retry the M-Doc sync.",
    mdocMissingDetailsHint:
      "Complete the highlighted fields, then save and retry.",
    mdocFirstNameRequired: "First name is required.",
    mdocMobileRequired: "Please enter a valid 10-digit mobile number.",
    mdocEmailRequiredHint: "A valid email is required to sync with M-Doc.",
    mdocDobOptionalHint: "Optional. Leave blank if the date of birth is unknown.",
    mdocDobInvalid: "Please enter a realistic date of birth.",
    mdocRetrySuccess: "Lead sent to M-Doc successfully.",
    mdocRetryAlreadySynced: "This lead was already synced to M-Doc.",
    mdocRetryFailed: "Could not retry M-Doc sync. Please try again.",
    mdocRetrying: "Retrying…",
    success: "Success",
    failed: "Failed",
    failure: "Failure",
    copy: "Copy",
    expand: "Expand",
    collapse: "Collapse",
    noDataFound: "No data found",
    mobile: "Mobile",

    //Chanel Partner Report
    getAllChanelPartnerData: "Channel Partner Report",
    getAllChanelPartnerDataListing: "Channel Partner Report Listing",

    //Channel Partner Appointment Report
    channelpartnerappointments: "Channel Partner Appointment Report",
    channelpartnerappointmentsListing:
      "Channel Partner Appointment Report Listing",
    serchByCpName: "Search By Cp Name",
    serchBySMName: "Search By SM Name",
    serchBySTLName: "Search By STL Name",

    //closing managers
    closingManagerList: "Lsit of Closing Managers",
    closingManagerListing: "Closing Manager Listing",
    noBookings: "No of bookings",
    viewClosingManager: "View Closing Manager",
    editClosingManager: "Edit Closing Manager",
    cmDetails: "CM Details",
    cmInfo: "CM INFO",

    //sm
    noOfSiteVisits: "No of Site Visit",
    noOfLeads: "No of Leads",
    viewSourcingManager: "View Sourcing Manager",
    editSourcingManager: "Edit Sourcing Manager",
    conversionPercentage: "Conversion Percentage",
    sourcingManagerListing: "Sourcing Manager Listing",
    sourcingManagerList: "Lsit of Sourcing Managers",
    smDetails: "SM Details",
    smInfo: "SM INFO",
    totalVisits: "Total Visit",
    fullName: "Full Name",
    allocateCp: "Allocate Cp",

    //appointmentWith cp
    apptWithCp: "Appointment With CP",
    appointmentListCP: "Appointment With CP Listing",
  },
});

export default strings;
